/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionCatalogPartMaterialPriceDataDto } from '../../models/auction-catalog-part-material-price-data-dto';
import { AuctionCatalogPartMaterialPriceDto } from '../../models/auction-catalog-part-material-price-dto';

export interface SetAuctionCatalogPartMaterialPrices$Params {
  partId: number;
  'X-API-Version'?: string;
      body: Array<AuctionCatalogPartMaterialPriceDataDto>
}

export function setAuctionCatalogPartMaterialPrices(http: HttpClient, rootUrl: string, params: SetAuctionCatalogPartMaterialPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuctionCatalogPartMaterialPriceDto>>> {
  const rb = new RequestBuilder(rootUrl, setAuctionCatalogPartMaterialPrices.PATH, 'put');
  if (params) {
    rb.path('partId', params.partId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AuctionCatalogPartMaterialPriceDto>>;
    })
  );
}

setAuctionCatalogPartMaterialPrices.PATH = '/api/auction-catalogs/parts/{partId}/material-prices';
